import {
  ActionList,
  ActionListItem,
  Box,
  Dropdown,
  DropdownOverlay,
  IconButton,
  LockIcon,
  SelectInput,
  Text,
  TextInput,
  Tooltip,
  TooltipInteractiveWrapper,
  TrashIcon,
} from '@razorpay/blade/components';
import {
  SalaryStructureComponent,
  SalaryStructureComponentValueType,
} from 'components/SalaryStructure/types';
import { isComponentDeletable } from 'components/SalaryStructure/utils';
import React, { useState } from 'react';
import { SalaryStructureComponentValueTypeLabels } from '../constants';
import { ComopnentWrapper } from './styles';

interface SalaryComponentProps {
  component: SalaryStructureComponent;
  onValueChange: (value: string) => void;
  onBaseChange: (base: string) => void;
  onDelete: () => void;
}

export const SalaryComponentItem: React.FC<SalaryComponentProps> = ({
  component,
  onDelete,
  onValueChange,
  onBaseChange,
}) => {
  const isSpecialAllowance =
    component.salaryComponent.componentType === 'COMPONENT_TYPE_SPECIAL_ALLOWANCE';
  const isDeletable = isComponentDeletable(component);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <ComopnentWrapper isDeleting={isDeleting}>
      <Box
        paddingX="10px"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        paddingY="spacing.3">
        <Box
          display="grid"
          gridTemplateColumns="1fr auto auto"
          alignItems="center"
          gap="spacing.3"
          width="100%">
          <Text size="medium">
            {component?.salaryComponent?.settings?.behaviour.displayBehaviour?.displayName ||
              component.salaryComponent.name}
          </Text>
          {isSpecialAllowance ? (
            <Box
              display="flex"
              flexDirection="column"
              placeSelf="flex-end"
              gap="spacing.1"
              textAlign="right">
              <Text size="medium" weight="regular">
                Residual component
              </Text>
              <Text variant="caption" size="small" weight="regular" color="surface.text.gray.muted">
                CTC - Sum of all other component
              </Text>
            </Box>
          ) : (
            <Box display="flex" alignItems="center" gap="spacing.3" placeSelf="flex-end">
              <Box width="150px">
                <TextInput
                  label=""
                  value={component.formula}
                  size="medium"
                  onChange={({ value: newValue }) => onValueChange(newValue || '')}
                />
              </Box>
              <Box width="150px">
                <Dropdown selectionType="single">
                  <SelectInput
                    label=""
                    value={component.valueType}
                    onChange={(e) => onBaseChange(e.values[0] as SalaryStructureComponentValueType)}
                    placeholder="Value Type"
                    accessibilityLabel="Value Type"
                  />
                  <DropdownOverlay>
                    <ActionList>
                      {Object.entries(SalaryStructureComponentValueTypeLabels).map(
                        ([key, value]) => (
                          <ActionListItem key={key} title={value.label} value={key} />
                        ),
                      )}
                    </ActionList>
                  </DropdownOverlay>
                </Dropdown>
              </Box>
            </Box>
          )}
          <Box marginLeft="spacing.8">
            {isDeletable ? (
              <IconButton
                isHighlighted
                icon={TrashIcon}
                onClick={onDelete}
                emphasis="intense"
                size="medium"
                isDisabled={!isDeletable}
                onMouseMove={() => setIsDeleting(true)}
                onMouseLeave={() => setIsDeleting(false)}
                accessibilityLabel="Delete component"
              />
            ) : (
              <Tooltip content="Component is required in the salary structure as per government compliance">
                <TooltipInteractiveWrapper
                  display="grid"
                  placeItems="center"
                  width="100%"
                  minWidth="spacing.8">
                  <LockIcon color="surface.icon.gray.disabled" size="medium" />
                </TooltipInteractiveWrapper>
              </Tooltip>
            )}
          </Box>
        </Box>
      </Box>
    </ComopnentWrapper>
  );
};
